export const getFormattedPrice = (price: number, currency: string, locale: string) => {
  return price
    ? Intl.NumberFormat(locale, { style: 'currency', currencyDisplay: 'narrowSymbol', currency }).format(price)
    : 0;
};
